export const apiURL = process.env.API_URL;
export const baseURL = process.env.BASE_URL;
export const host = process.env.HOST;
export const imageBaseURL = process.env.IMG_BASE_URL;
export const xFunctionsKey = process.env.X_FUNCTIONS_KEY;
export const sentryUrl = process.env.SENTRY_API_URL;
export const ocpApimSubscriptionKey = process.env.OCP_APIM_SUBSCRIPTION_KEY;
